export default "__VITE_ASSET__Dwjo51rk__"